import { Button, DateBox, LoadIndicator, SelectBox } from 'devextreme-react';
import { Column } from 'devextreme-react/data-grid';
import { formatMessage } from 'devextreme/localization';
import React, { useEffect, useState, useMemo } from 'react';
import DataGridMVP from '../../DataGridMVP';
import HeaderButtonMVP from '../../HeaderButtonMVP';
import PopupMVP from '../../PopupMVP';
import SearchBar from '../../SearchBar/SearchBar';
import styles from './pieceAdmin.module.scss';
import columnDataGrid from './columnDataGrid';
import { normalizeDateToSend } from '../../../utils/functions';

const PieceAdmin = ({
  adminReducer: {
    listPieces,
    listStatuses,
    dataGetPieces,
    dataChangePlant,
    dataChangeStatus,
    dataGetStatuses
  },
  getPiecesList,
  stockReducer: { listStocks },
  changePiecesPlant,
  changePiecesStatus,
  getStatusesList,
  plantId
}) => {
  // eslint-disable-next-line
  const [thisDataGridInstance, setThisDataGridInstance] = useState({});
  const [inputValue, setInputValue] = useState('');
  const [headButtVisible, setHeadButtVisible] = useState({ display: 'none' });
  const [selectedPieceIds, setSelectedPieceIds] = useState([]);
  const [isChangePlantPopupVisible, setIsChangePlantPopupVisible] = useState(false);
  const [isChangeStatusPopupVisible, setIsChangeStatusPopupVisible] = useState(false);
  const [selectedPlant, setSelectedPlant] = useState();
  const [selectedStatus, setSelectedStatus] = useState();
  const [selectedDate, setSelectedDate] = useState();
  const selectBoxDisplayExpr = useMemo(
    () => (item) => (item ? `${item.plantFullDescr}` : ''),
    []
  );
  const selectStatusExpr = useMemo(
    () => (item) => (item ? `${item.name}` : ''),
    []
  );

  useEffect(() => {
    getStatusesList();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    plantId,
    dataChangePlant.okRequest,
    dataChangeStatus.okRequest,
    getStatusesList
  ]);

  useEffect(() => {
    if (thisDataGridInstance.instance) {
      if (dataGetPieces.loadingData) {
        thisDataGridInstance.instance.beginCustomLoading('Loading...');
      } else {
        thisDataGridInstance.instance.endCustomLoading();
      }
    }
  }, [dataGetPieces.loadingData, thisDataGridInstance]);

  useEffect(() => {
    if (selectedPieceIds.length) {
      setHeadButtVisible({ display: 'flex', top: '55px' });
    } else {
      setHeadButtVisible({ display: 'none' });
    }
  }, [selectedPieceIds.length]);

  const onClickSearch = () => {
    getPiecesList({
      filter: inputValue,
      plantId
    });
  };

  const onHidingModals = () => {
    setIsChangePlantPopupVisible(false);
    setIsChangeStatusPopupVisible(false);
  };

  const onClickChangePlant = () => {
    changePiecesPlant({
      pieceNumIds: selectedPieceIds,
      plantId: selectedPlant
    });
    onHidingModals();
    getPiecesList({
      filter: inputValue,
      plantId
    });
  };

  const onClickChangeStatus = () => {
    changePiecesStatus({
      pieceNumIds: selectedPieceIds,
      date: selectedDate,
      statusId: selectedStatus
    });
    onHidingModals();
    getPiecesList({
      filter: inputValue,
      plantId
    });
  };

  const onChangePlant = ({ value }) => {
    setSelectedPlant(value.plantId);
  };

  const onChangeStatus = ({ value }) => {
    setSelectedStatus(value.id);
  };

  const renderChangePlantPopup = (
    <PopupMVP
      visible={isChangePlantPopupVisible}
      title={formatMessage('administrationTabs').buttons.changePlant}
      onHiding={onHidingModals}
    >
      <div className="formData">
        <span>{formatMessage('textTabListStock')}</span>
        <SelectBox
          items={listStocks}
          displayExpr={selectBoxDisplayExpr}
          keyExpr={'id'}
          disabled={!listStocks.length}
          onValueChanged={onChangePlant}
          stylingMode="outlined"
          value={selectedPlant && selectedPlant.plantFullDescr}
          searchEnabled
          // Ограничение высоты для выпадающего меню
          // onOpened={(e) => {
          //   e.component._popup.option('maxHeight', '20%');
          // }}
        />
        <div className="formButton">
          <Button
            type="default"
            stylingMode="contained"
            onClick={onClickChangePlant}
            text={formatMessage('textButton').save}
          />
          <Button
            type="danger"
            stylingMode="contained"
            onClick={onHidingModals}
            text={formatMessage('textButton').cancel}
          />
        </div>
      </div>
    </PopupMVP>
  );

  // При статусе "В наличии"
  const receiptCondition = selectedStatus === 2;

  // При статусах "Отгружен" "Переработан" "Удален"
  const shippingCondition = selectedStatus === 5 || selectedStatus === 9 || selectedStatus === 20;

  const isStatusFilles = ((receiptCondition || shippingCondition) && selectedDate)
    || (!receiptCondition && !shippingCondition);

  const renderChangeStatusPopup = (
    <PopupMVP
      visible={isChangeStatusPopupVisible}
      className={styles.changeStatusPopup}
      title={formatMessage('administrationTabs').buttons.changeStatus}
      onHiding={onHidingModals}
      height="content-fit"
    >
      <div className="formData">
        {(dataGetStatuses.loadingData) ? (
          <LoadIndicator className={styles.loadIndicator} />
        ) : (
          <>
            <span>{'Статус'}</span>
            <SelectBox
              items={listStatuses}
              // items={statuses}
              displayExpr={selectStatusExpr}
              disabled={!listStatuses.length}
              onValueChanged={onChangeStatus}
              stylingMode="outlined"
              // onOpened={(e) => {
              //   e.component._popup.option('maxHeight', '20%');
              // }}
            />
          </>
        )}
        <div className={styles.changeStatusDate}>
          <span>
            {receiptCondition && 'Дата приема'}
            {shippingCondition && 'Дата отгрузки'}
          </span>
          {(receiptCondition || shippingCondition) && (
            <DateBox
              displayFormat="dd.MM.yyyy"
              dateSerializationFormat="yyyy-MM-dd"
              useMaskBehavior
              stylingMode="outlined"
              openOnFieldClick
              value={selectedDate}
              onValueChanged={({ value }) => {
                setSelectedDate(normalizeDateToSend(value));
              }}
            />
          )}
        </div>
        <div className="formButton">
          <Button
            type="default"
            stylingMode="contained"
            onClick={onClickChangeStatus}
            disabled={!isStatusFilles}
            text={formatMessage('textButton').save}
          />
          <Button
            type="danger"
            stylingMode="contained"
            onClick={onHidingModals}
            text={formatMessage('textButton').cancel}
          />
        </div>
      </div>
    </PopupMVP>
  );

  const renderColumnDataGrid = useMemo(
    () =>
      columnDataGrid.map((item) => (
        <Column
          dataField={item.dataField}
          caption={formatMessage('textTable').consignment[item.dataField]}
          visible={!item.notVisible}
          allowSearch={false}
          allowFiltering
          cellRender={item.cellRender}
          key={item.dataField}
          dataType={item.dataType}
          cssClass={item.cssClass}
        />
      )),
    []
  );

  return (
    <>
      <SearchBar
        inputValue={inputValue}
        setInputValue={setInputValue}
        onClickSearch={onClickSearch}
      />
      <HeaderButtonMVP headButtVisibol={headButtVisible}>
        <Button
          text={formatMessage('administrationTabs').buttons.changePlant}
          icon="edit"
          type={'default'}
          stylingMode={'contained'}
          onClick={() => {
            setIsChangePlantPopupVisible(true);
          }}
        />
        <Button
          text={formatMessage('administrationTabs').buttons.changeStatus}
          icon="edit"
          type={'default'}
          stylingMode={'contained'}
          onClick={() => {
            setIsChangeStatusPopupVisible(true);
          }}
        />
      </HeaderButtonMVP>
      <div className={styles.dataGridWrapper}>
        <DataGridMVP
          dataSource={listPieces}
          setDataGridInstance={setThisDataGridInstance}
          className="pieceAdmin"
          keyExpr="pieceNumId"
          onSelectionChanged={({ selectedRowKeys }) => {
            setSelectedPieceIds(selectedRowKeys);
          }}
          setStateStoringName={'dataGridAdminPieces'}
          loadingData={
            dataGetPieces.loadingData
            || dataChangePlant.loadingData
            || dataChangeStatus.loadingData
            || dataGetPieces.loading
          }
          visibleButtonDateRangePicker={false}
          setFilterDataGrid={() => {}}
          dataGridOnOptionChanged={() => {}}
          tText={formatMessage('textPeriod')}
          filterDataGrid
        >
          {renderColumnDataGrid}
        </DataGridMVP>
      </div>
      {renderChangePlantPopup}
      {renderChangeStatusPopup}
    </>
  );
};

export default React.memo(PieceAdmin);
